import { createApiSlice } from "@common";
import { CRUD_MARKET_SEGMENT } from "@routes";

const apiConfig = [
  {
    name: "addMarketSegment",
    method: "post",
    url: CRUD_MARKET_SEGMENT,
    stateKey: "message"
  },
  {
    name: "getMarketSegment",
    method: "get",
    url: CRUD_MARKET_SEGMENT,
    stateKey: "data"
  },
  {
    name: "updateMarketSegment",
    method: "put",
    url: CRUD_MARKET_SEGMENT,
    stateKey: "message"
  },
  {
    name: "deleteMarketSegment",
    method: "delete",
    url: CRUD_MARKET_SEGMENT,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "marketSegment",
  apiConfig,
  customReducers);
const marketSegmentSlice = slice;

export default marketSegmentSlice.reducer;

export const {
  addMarketSegment
  , getMarketSegment,
  updateMarketSegment,
  deleteMarketSegment
} = thunks;
export const { rowSelect } = actions;
